import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const bayLocationsAdapter = getAdapter();

const bayLocationsSlice = createSlice({
  name: 'bayLocations',
  initialState: bayLocationsAdapter.getInitialState(),
  reducers: {
    setBayLocations: (state, { payload: { bayLocations } }) => {
      bayLocationsAdapter.setAll(state, bayLocations);
    },
  },
});

const selectors = bayLocationsAdapter.getSelectors(({ bayLocations }) => bayLocations);

export const getBayLocationsIncludingDeleted = (state) => selectors.selectAll(state);

export const getBayLocations = (state) => getBayLocationsIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setBayLocations,
} = bayLocationsSlice.actions;

export default bayLocationsSlice.reducer;